<template>
    <div class="vote-form">
        <form :action="submitUrl" method="post">
            <div class="form-group row">
                <label class="col-2 col-form-label text-right"><span
                    class="text-danger align-middle">*</span> 投票名称
                </label>
                <div class="col-10">
                    <input type="text" class="form-control" placeholder="投票名称" maxlength="30" autocomplete="off"
                           v-model="name">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-2 col-form-label text-right"><span
                    class="text-danger align-middle">*</span> 投票描述
                </label>
                <div class="col-10">
                    <textarea class="form-control" placeholder="投票描述" rows="4"
                              v-model="desc"></textarea>
                </div>
            </div>

            <div v-if="isCreateForm" class="form-group row">
                <label
                    class="col-2 col-form-label text-right">单选/多选</label>
                <div class="col-10 pt-2">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="genderMale" name="optionType"
                               class="custom-control-input" value="0" v-model="optionType">
                        <label class="custom-control-label"
                               for="genderMale">单选</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="genderFemale" name="optionType"
                               class="custom-control-input" value="1" v-model="optionType">
                        <label class="custom-control-label"
                               for="genderFemale">多选</label>
                    </div>
                </div>
            </div>

            <div v-if="isCreateForm" class="form-group vote-content-container">
                <div>
                    <div class="vote-item" v-for="(item, index) in items" :key="item.id">
                        <div class="item-title">
                            <input type="text" class="form-control" name="items[]" autocomplete="off" placeholder="投票内容"
                                   v-model="item.title">
                        </div>
                        <div class="item-image">
                            <file-uploader v-model="item.image" name="image" >
                                <i class="icon icon-icon-test" slot="text"></i>
                            </file-uploader>
                        </div>
                        <div class="item-del-btn">
                            <i class="icon icon-baseline-close-px" @click="delItem(item.id)"></i>
                        </div>
                    </div>
                </div>
                <a class="add-item-btn" @click="addItem"><i class="icon icon-icon-test"></i> 添加项目</a>
            </div>

            <div class="form-group text-center">
                <button type="button" class="btn btn-primary" @click="submit">确定</button>
            </div>
        </form>
    </div>
</template>

<script>
// import AppUploader from './Uploader'
import FileUploader from "./FileUploader"

export default {
    name: "VoteForm",
    components: {
        FileUploader
    },
    props: {
        type: String,
        submitUrl: String,
        interaction: {
            type: Object,
            default: null
        }
    },
    computed: {
        isCreateForm() {
            return this.interaction == null
        }
    },
    data() {
        return {
            name: this.interaction ? this.interaction.title : '',
            desc: this.interaction ? this.interaction.content : '',
            items: [],
            optionType: '0'
        }
    },
    mounted() {
        [0,0,0,0].forEach(() => this.addItem());
    },
    methods: {
        addItem() {
            const defaultItem = {
                id: 'T_'+Math.random(),
                title: '',
                image: null
            }
            this.items.push(defaultItem)
        },
        delItem(index) {
            const i = this.items.findIndex(rec => rec.id === index);
            if (this.items.length <= 2) {
                common.msg('error', '至少保留两个选项')
            } else {
                this.items.splice(i, 1);
            }
        },
        submit() {
            let formData;
            if (!this.isCreateForm) {
                formData = {
                    type: this.type,
                    uuid: this.interaction ? this.interaction.uuid : '',
                    title: this.name,
                    content: this.desc,
                }
            } else {
                formData = {
                    type: this.type,
                    title: this.name,
                    content: this.desc,
                    option_type: this.optionType,
                    items: this.items
                }
            }

            $.ajax({
                type: 'POST',
                url: this.submitUrl,
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: common.ajax_callback,
                error: common.error
            });
        }
    }
}
</script>

<style lang="scss">
.item-image {
    .upload-widget {
        .custom-file.type-img {
            width: 60px;
            height: 60px;
            cursor: pointer;

            label {
                width: 100%;
                height: 100%;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;

                i {
                    font-size: 20px;
                    cursor: pointer;
                }
            }
        }

        .img-item {
            width: 60px;
            height: 60px;
            overflow: hidden;

            img {
                width: 54px;
                height: 54px;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.vote-form {
    padding-bottom: 10px;

    .vote-content-container {
        .vote-item {
            display: flex;
            align-items: center;

            margin-bottom: 10px;

            > div {
                &:not(:last-child) {
                    margin-right: 10px;
                }
            }

            .item-title {
                flex: 1;
            }

            .item-image {
                width: 60px;
                height: 60px;
            }

            .item-del-btn {
                &:hover {
                    cursor: pointer;
                }

                i.icon {
                    font-size: 24px;
                }
            }
        }

        .add-item-btn {
            cursor: pointer;
            margin-top: 10px;
        }
    }
}
</style>
